export const tasksUrl = 'tasks/';
